import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/module',
  component: Layout,
  name: 'moduleManagement',
  meta: {
    title: '模块管理',
    icon: 'i-ep:grid',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'moduleList',
      component: () => import('@/views/module/index.vue'),
      meta: {
        title: '模块列表',
        icon: 'i-ep:grid',
      },
    },
    {
      path: 'add',
      name: 'moduleAdd',
      component: () => import('@/views/module/form.vue'),
      meta: {
        title: '添加模块',
        icon: 'i-ep:plus',
        menu: false,
      },
    },
    {
      path: 'edit/:id',
      name: 'moduleEdit',
      component: () => import('@/views/module/form.vue'),
      meta: {
        title: '编辑模块',
        icon: 'i-ep:edit',
        menu: false,
      },
    },
    {
      path: 'detail/:id',
      name: 'moduleDetail',
      component: () => import('@/views/module/detail.vue'),
      meta: {
        title: '模块详情',
        icon: 'i-ep:document',
        menu: false,
      },
    },
    {
      path: 'permissions',
      name: 'modulePermissions',
      component: () => import('@/views/module/permission.vue'),
      meta: {
        title: '菜单权限',
        icon: 'i-ep:key',
      },
    },
    {
      path: 'gifts',
      name: 'moduleGiftRecords',
      component: () => import('@/views/team/module-gifts.vue'),
      meta: {
        title: '模块赠送记录',
        icon: 'i-ep:document',
      },
    },
    {
      path: 'add-menu',
      name: 'moduleAddMenu',
      component: () => import('@/views/module/add-menu.vue'),
      meta: {
        title: '添加菜单',
        icon: 'i-ep:plus',
        menu: false,
      },
    },
  ],
}

export default routes
